import { AvaLoadingAnimation } from "@doitintl/ava-components/src/Messenger/AvaLoadingAnimation";

import { useDarkThemeCheck } from "../hooks/useDarkThemeCheck";
import AvaTextLoading from "./AvaTextLoading";

type Props = {
  isGeneratingReport?: boolean;
  avaChatLoading?: string;
};

export const AvaLoading = ({ avaChatLoading }: Props) => {
  const isDarkMode = useDarkThemeCheck();

  return (
    <> {avaChatLoading ? <AvaTextLoading text={avaChatLoading} /> : <AvaLoadingAnimation isDarkMode={isDarkMode} />}</>
  );
};
